import { getApi } from 'common/modules/ReactShared';
import { ILessonsRequestParams, ILessonsResponse } from './types';

export async function getLessons(
  params?: ILessonsRequestParams
): Promise<ILessonsResponse> {
  const { data } = await getApi().get<ILessonsResponse>(`/profile/lessons`, {
    params
  });

  return data;
}

export async function deleteLesson(id: number): Promise<void> {
  await getApi().delete<void>(`lesson_sessions/${id}/cancel`);
}
